import { IPaymentProvider } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const paymentProviderApi = crudEndpointsFactory<IPaymentProvider>()('payment-providers', 'PaymentProviders');
